import * as React from 'react';



export default class BulkInbox extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
            <svg className={this.props.className} id="bulkinbox" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 8H23.6923" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <path d="M7.8457 12H23.538" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <path d="M7.8457 16H15.5357" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <path d="M7.8457 20H13.5357" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <path d="M7.8457 24H14.5357" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <path d="M5 8H5.5" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <path d="M5 12H5.5" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <path d="M5 16H5.5" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <path d="M5 20H5.5" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <path d="M5 24H5.5" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"></path>
              <circle cx="21.6923" cy="20.9229" r="7.55769" stroke="#333333" strokeWidth="1.5"></circle>
              <path d="M18 20.923L20.7692 23.6923L26.3077 18.1538" stroke="#333333" strokeWidth="1.5"></path>
            </svg>
    )
  }
}
